import React from "react";
import {
  Card,
  CardContent,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

export default function UserInspectionConsentsDialog({
  open,
  onClose,
  consents,
}) {
  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle>Consensi</DialogTitle>
      <DialogContent>
        <Card>
          {consents?.length ? (
            <CardContent>
              <div style={{ width: "100%" }}>
                {consents.map((k) => {
                  if (!k) return null;
                  return (
                    <table key={k.id}>
                      <tbody>
                        <tr>
                          <td>Tipo</td>
                          <td>{k.type}</td>
                        </tr>
                        <tr>
                          <td>Titolo</td>
                          <td>{k.title}</td>
                        </tr>
                        <tr>
                          <td>Testo</td>
                          <td>{k.text}</td>
                        </tr>
                        <tr>
                          <td>Richiesta</td>
                          <td>{k.agreement_text}</td>
                        </tr>
                        <tr>
                          <td>Valido da</td>
                          <td>
                            {k.from} a {k.to}
                          </td>
                        </tr>
                        <tr>
                          <td>Stato</td>
                          <td>{k.status}</td>
                        </tr>
                        <tr>
                          <td>Obbligatorio</td>
                          <td>{k.mandatory}</td>
                        </tr>
                        <tr>
                          <td>Richiesto</td>
                          <td>{k.force_signature}</td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}
              </div>
            </CardContent>
          ) : null}
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
}
